module.exports = __webpack_public_path__ + "static/media/shiguchejieshouren.933ee37e.png";